import { render, staticRenderFns } from "./FileUploaderNoFiles.vue?vue&type=template&id=21e6c0a0&scoped=true&"
import script from "./FileUploaderNoFiles.vue?vue&type=script&lang=js&"
export * from "./FileUploaderNoFiles.vue?vue&type=script&lang=js&"
import style0 from "./FileUploaderNoFiles.vue?vue&type=style&index=0&id=21e6c0a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6c0a0",
  null
  
)

export default component.exports